
$('.autoplay').slick({
	slidesToShow: 3,
	//slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 0,
	speed: 7800,
	cssEase: "linear",
	useTransform:false,
	responsive: [
	  {
		breakpoint: 426,
		settings: {
		  slidesToShow: 2
		}
	  }
	]
  });